import routerOptions0 from "/home/runner/work/zeronet-web/zeronet-web/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}